export default __webpack_public_path__ + "static/media/phoneIcon.c859e3cb.svg";